import Vue from "vue";
import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import { Http } from "@status/codes";
import { QuerySend, QuerySendMultiple } from "@/shared/models/FormQuerySend";
import { ServiceTemplateHeader } from "@/modules/ServiceTemplate/models/ServiceTemplateHeader";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { ServiceTemplateModel } from "@/modules/ServiceTemplate/models/ServiceTemplateModel";
import {
  MODAL_CONFIRMATION_MESSAGE,
  SERVICES_ACCESS,
  SERVICES_CONTANTS,
  SERVICES_STATE,
  SERVICE_LIST_IDS,
  SERVICE_FILTERS,
  SERVICE_STATES,
  SERVICE_STATE_COLORS
} from "@/modules/Services/constants/ServicesConstants";
import { Service } from "@/modules/Services/models/Service";
import { ServiceUpdate } from "@/modules/Services/models/ServiceUpdate";
import { ServicesService } from "@/modules/Services/services/ServicesService";
import { Utils } from "@/shared/utils/utils";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { AssignedServices } from "@/modules/Services/models/AssignedServices";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { CupsPriceLevelService } from "@/modules/CupsPriceLevels/services/CupsPriceLevelService";
import { ArrayByKeys } from "@/shared/models/ArrayByKeys";
import { RuleService } from "@/modules/Rules/services/RuleService";
import { OrderService } from "@/modules/Orders/services/OrderService";
import { ListService } from "@/modules/List/services/ListService";
import {
  GENERAL_CONSTANTS,
  NAME_FINDERS
} from "../../../../shared/constants/GeneralConstants";
import { SectionGroup } from "../../../ServiceTemplate/models/SectionGroup";
import {
  SectionGroupDetail,
  SectionGroupDetailShort
} from "../../../ServiceTemplate/models/SectionGroupDetail";
import { SavedItems } from "../../../MedicalOrder/models/SavedSessions";
import { SectionGroupData } from "../../../MedicalOrder/models/SectionGroupData";
import { ServiceHeaderData } from "@/modules/Services/models/ServiceHeaderData";
import InfoModalTemplate from "@/shared/components/InfoModalTemplate/InfoModalTemplate.vue";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import lodash from "lodash";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { SERVICE_TEMPLATES_ACCESS } from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import { CUPS_ACCESS } from "@/modules/CupsPriceLevels/constants/CupsPriceLevelConstants";
import {
  EXTRA_CONSTANTS,
  PROFILE_CONSTANTS
} from "../../constants/ProfileConstants";
import { LACK_OF_OPTIONS } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";
import { AxiosError } from "axios";

@Component({
  name: "AssignServiceTemplate",
  components: {
    ModalTemplate,
    EmptyState,
    InfoModalTemplate,
    GenericSearchBar
  }
})
export default class AssignServiceTemplate extends Vue {
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() servicesService!: ServicesService;
  @Inject() cupsPriceLevelService!: CupsPriceLevelService;
  @Inject() listService!: ListService;
  @Inject() orderService!: OrderService;
  @Inject() ruleService!: RuleService;
  @Prop() dialogAssign!: boolean;
  @Prop() user!: string;
  @Prop() userDoc?: string;
  @Prop() data?: ServiceHeaderData[];
  @Prop() justStepper?: boolean;
  @Prop() serviceTemplateId?: string;
  @Prop() service?: ServiceHeaderData;

  cardClass = STYLE_CLASSES.CARD;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  rowForms = STYLE_CLASSES.ROW_FORMS;
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  btnClassPrimaryRound = STYLE_CLASSES.BASIC_ROUND_BTN;

  DOCUMENT = PROFILE_CONSTANTS.PROFILE_ITEMS.DOCUMENT + ": ";
  TITLE_TEXT = SERVICES_CONTANTS.BUTTON.ASSIGN_SERVICE;
  HELP_TEXT = SERVICES_CONTANTS.HELP_TEXT;
  SAVE_BUTTON = FORM_CONSTANTS.BUTTON.SAVE;
  CLOSE_BUTTON = FORM_CONSTANTS.BUTTON.CLOSE;
  STATE_TEXT = SERVICES_CONTANTS.LABEL.STATE;
  CATEGORY_TEXT = SERVICES_CONTANTS.LABEL.CATEGORY;
  TYPE_TEXT = SERVICES_CONTANTS.LABEL.TYPE;
  CUPS_TEXT = SERVICES_CONTANTS.LABEL.CUPS;
  DESC_TEXT = SERVICES_CONTANTS.LABEL.DESCRIPTION;
  CLEAN_GROUPS_TEXT = SERVICES_CONTANTS.LABEL.CLEAN_GROUPS;
  SELECT_PRICE_LVL = SERVICES_CONTANTS.LABEL.SELECT_PRICE_LEVEL;
  CONTRACT_TYPE = SERVICES_CONTANTS.LABEL.CONTRACT_TYPE;
  CHARGE_CONCEPT = SERVICES_CONTANTS.LABEL.CHARGE_CONCEPT;
  ATTENTION_TYPE = SERVICES_CONTANTS.LABEL.ATTENTION_TYPE;
  USER_TYPE = SERVICES_CONTANTS.LABEL.USER_TYPE;
  SELECT_CUPS = SERVICES_CONTANTS.LABEL.CUPS_FIELD;
  SEARCH_TEXT = FORM_CONSTANTS.BUTTON.SEARCH;
  ASSIGN_TEXT = SERVICES_CONTANTS.LABEL.ASSIGN_PRICE_LEVEL;
  ASSIGNED_SERV_TEXT = SERVICES_CONTANTS.LABEL.ASSIGNED_SERVICES;
  modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
  modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
  EMPTY_STATE_HEADER = SERVICES_CONTANTS.MESSAGE.EMPTY_HEADER;
  EMPTY_STATE_PARAGRAPH = SERVICES_CONTANTS.MESSAGE.EMPTY_PARAGRAPH;
  COLORS = SERVICE_STATE_COLORS;
  ASSIGN_SERVICE_LABEL = SERVICES_CONTANTS.LABEL.ASSIGN_SERVICE;
  EXTERNAL_ORDER_NUMBER = SERVICES_CONTANTS.LABEL.EXTERNAL_ORDER_NUMBER;
  SELECTED_CHIP = STYLE_CLASSES.CHIP_COLOR.SELECTED;
  assignTypes = GENERAL_CONSTANTS.ASSIGN_TYPES_LIST;
  GROUP_TYPE = GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TYPE;
  SECTION_TEXT = GENERAL_CONSTANTS.SERVICE_TYPES.SECTION_TEXT;
  GROUP_TEXT = GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TEXT;
  SECTION_TYPE = GENERAL_CONSTANTS.SERVICE_TYPES.SECTION_TYPE;
  PERSONALIZED = SERVICES_CONTANTS.LABEL.PERSONALIZED_STATE;
  SEE_SESSIONS = SERVICES_CONTANTS.BUTTON.SEE_SESSIONS;
  NO_MULTIPLE_INSTANCES = GENERAL_CONSTANTS.TEXTS.NO_MULTIPLE_INSTANCES;
  NOT_ALLOWED = GENERAL_CONSTANTS.TEXTS.NOT_ALLOWED;
  SEARCH_ASSIGNE_SERVICE_KEY = NAME_FINDERS.ASSIGNE_SERVICE;

  price = "";
  contractType = "";
  userType = "";
  attentionType = "";
  chargeConcept = "";
  serviceAssignType = "";
  externalOrderNumber = "";
  requiredOrder = false;
  step = 2;
  loadingData = false;
  updatingService = false;
  serviceTemplates: ServiceTemplateHeader[] = [];
  servicesAssigned: AssignedServices[] = [];
  serviceTemplate: ServiceTemplateModel = new ServiceTemplateModel();
  cups = "";
  priceLevels: ArrayByKeys[] = [];
  contractTypes: ArrayByKeys[] = [];
  userTypes: ArrayByKeys[] = [];
  attentionTypes: ArrayByKeys[] = [];
  chargeConcepts: ArrayByKeys[] = [];
  dialogAccept = false;
  filterItems: QuerySendMultiple = {};
  lastServiceRef = "";
  filterArray: Filter[] = lodash.cloneDeep(SERVICE_FILTERS) as Filter[];
  groupSectionSelected: SectionGroup | string = "";
  currentSectionGroups: SectionGroup[] = [];
  groupSections: SectionGroup[] | undefined = [];
  serviceTempType = "";
  groupSectionAssignType = "";
  sessionsFormTemps: SectionGroupDetail[] = [];
  currentItems: SectionGroupDetail[] = [];
  savedItems: SavedItems[] = [];
  dialogConfirm = false;
  modalTextConfirm: string = MODAL_CONFIRMATION_MESSAGE.TEXT;
  modalTitleConfirm: string = MODAL_CONFIRMATION_MESSAGE.TITLE;
  serviceId = "";
  dialogAllowSeveralInstances = false;
  updatedItem = false;
  updatedGroupSections = false;
  serviceCups: ArrayByKeys[] = [];
  cupsSelected = "";
  loadingSectionsOrGroups = false;

  get assignGroupSectionLabel(): string {
    if (this.serviceTemplate.type == this.GROUP_TYPE)
      return SERVICES_CONTANTS.LABEL.ASSIGN_GROUP;
    else return SERVICES_CONTANTS.LABEL.ASSIGN_SECTION;
  }

  get sessionsFormTempLabel(): string {
    if (this.serviceTemplate.type == this.GROUP_TYPE)
      return SERVICES_CONTANTS.LABEL.SESSIONS;
    else return SERVICES_CONTANTS.LABEL.FORM_TEMPS;
  }

  created() {
    if (this.serviceTemplateId) {
      this.step = 3;
      this.updatingService = true;
      this.getServiceTemplate(this.serviceTemplateId);
    }
  }

  async mounted() {
    this.filterArray[0].secondaryFilters[1].options = await Utils.getListAndMapItAsSecondaryFilterOptions(
      SERVICE_LIST_IDS.CATEGORY
    );
    this.getContractTypes();
    this.getUserTypes();
    this.getAttentionTypes();
    this.getChargeConcepts();
    this.step = !this.justStepper ? 2 : 1;
    await this.searchServicesAssigned();
  }

  handlePriceLevelChange() {
    if (this.service) {
      const updatedData = { priceLevel: this.price };
      this.updateService(this.service.id, updatedData);
    }
  }

  handleCupsChange() {
    if (this.service) {
      const updatedData = { priceLevel: this.price };
      this.updateService(this.service.id, updatedData);
    }
  }

  handleExternalNumberChange() {
    if (this.service && this.externalOrderNumber) {
      const updatedData = {
        externalOrderNumberForCreation: this.externalOrderNumber
      };
      this.updateService(this.service.id, updatedData);
    }
  }

  async handleSectionsChange(serviceAssignType: string, shouldUpdate: boolean) {
    if (serviceAssignType === GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED) {
      this.loadingSectionsOrGroups = true;
      await this.getServiceTempleteWithSectionsOrGroups(
        this.serviceTemplate.id as string
      );
      this.loadingSectionsOrGroups = false;
    }

    if (this.updatingService && this.service) {
      let convertedData: SectionGroupData[] = [];

      if (serviceAssignType === GENERAL_CONSTANTS.ASSIGN_TYPE.COMPLETE) {
        const updatedData =
          this.serviceTemplate.type === this.SECTION_TYPE
            ? { sections: convertedData }
            : { groups: convertedData };
        this.updateService(this.service.id, updatedData);
      } else if (
        shouldUpdate &&
        serviceAssignType === GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED
      ) {
        convertedData = this.convertSectionGroups();
        const updatedData =
          this.serviceTemplate.type === this.SECTION_TYPE
            ? { sections: convertedData }
            : { groups: convertedData };
        this.updateService(this.service.id, updatedData);
      }
    }
  }

  async updateService(idService: string, serviceUpdate: ServiceUpdate) {
    try {
      const response = await this.servicesService.updateService(
        idService,
        serviceUpdate
      );
      if (response.code !== Http.Ok) {
        Snackbar.popWarning(SERVICES_CONTANTS.MESSAGE.UPDATE_FAILED);
      }
    } catch (error) {
      Snackbar.popWarning(SERVICES_CONTANTS.MESSAGE.UPDATE_FAILED);
    }
  }

  async searchServicesAssigned() {
    try {
      if (this.dialogAssign) {
        const response = await this.servicesService.getAssignedServices(
          this.user
        );

        if (response.code === Http.Found && response.data) {
          this.servicesAssigned = response.data.sort(
            (a, b) => b.dateCreated - a.dateCreated
          );
        } else {
          this.servicesAssigned = [];
        }
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      return Snackbar.popError(errorMessage);
    }
  }

  async getServiceFilterEvents(data: any) {
    delete data["mainFilterKey"];
    this.filterItems = { ...data };
    this.lastServiceRef = "";
    await this.searchData(data, false);
  }

  async searchData(
    filterQueryService: QuerySendMultiple,
    shouldPaginate?: boolean
  ) {
    if (!shouldPaginate) this.loadingData = true;

    const filterQuery: QuerySend = {
      state: FORM_CONSTANTS.STATE.ACTIVE,
      paginatedResult: true
    };

    try {
      if (filterQueryService.name)
        filterQuery.internalName = filterQueryService.name[0];

      if (filterQueryService.type)
        filterQuery.type = filterQueryService.type[0];

      if (filterQueryService.category)
        filterQuery.category = filterQueryService.category[0];

      if (this.lastServiceRef) filterQuery.docref = this.lastServiceRef;

      const response = await this.serviceTemplateService.getServiceTemplateWithFilters(
        filterQuery
      );

      if (response.code === Http.Found && response.data) {
        const serviceList = response.data.serviceTemplates;
        this.lastServiceRef = response.data.docref;
        if (shouldPaginate) {
          this.serviceTemplates = [...this.serviceTemplates, ...serviceList];
        } else {
          this.serviceTemplates = serviceList;
        }
      } else {
        if (!shouldPaginate) {
          this.serviceTemplates = [];
        }
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICE_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }

    this.loadingData = false;
  }

  close() {
    this.step = 1;
    this.price = "";
    this.$emit(GENERAL_CONSTANTS.V_ON_EVENTS.CLOSE_ASSIGN_SERVICE);
  }

  async verifyIfServiceTempIsAssigned(id: string) {
    const validation = this.data?.some(
      service =>
        service.serviceTemplateId === id &&
        service.state !== SERVICES_STATE.COMPLETED
    );

    const allowSeveralInstances = await this.allowSeveralInstances(id);

    if (validation && !allowSeveralInstances) {
      this.dialogAllowSeveralInstances = true;
      return;
    }

    if (validation) {
      this.dialogConfirm = true;
      this.serviceId = id;
      return;
    }

    await this.getServiceTemplate(id);
    this.dialogConfirm = false;
  }

  async getServiceTemplate(id: string) {
    try {
      this.loadingData = true;
      this.price = "";
      this.cupsSelected = "";
      this.cups = "";
      this.cleanServiceConfig();
      const response = await this.serviceTemplateService.getServiceTemplateByIdBasicInfo(
        id
      );

      if (response.code == Http.Found && response.data) {
        this.serviceTemplate = response.data;
        this.step = 3;

        if (this.serviceTemplate.type == this.GROUP_TYPE) {
          const arrayCups: string[] = [];
          const tempoGroups = response.data.groups ?? [];
          for (const iterator of tempoGroups) {
            arrayCups.push(iterator.cups as string);
          }
          await this.getCupsByService(arrayCups);
        } else {
          this.cupsSelected = this.serviceTemplate.cups ?? "";
        }

        if (this.cupsSelected) {
          await this.getPriceLevelsByCup(this.cupsSelected);
        }
        return;
      }

      Snackbar.popError(response.message);
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }

    this.loadingData = false;
  }

  async getServiceTempleteWithSectionsOrGroups(id: string) {
    try {
      const response = await this.serviceTemplateService.getServiceTemplateById(
        id
      );

      if (response.code == Http.Found && response.data) {
        this.serviceTemplate = response.data;
        this.step = 3;
        this.groupSections =
          response.data.type === this.GROUP_TYPE
            ? response.data.groups
            : response.data.sections;
        this.serviceTempType =
          response.data.type === this.GROUP_TYPE
            ? this.GROUP_TEXT
            : this.SECTION_TEXT;

        this.currentSectionGroups =
          this.currentSectionGroups && this.currentSectionGroups.length > 0
            ? this.currentSectionGroups
            : (this.groupSections?.slice() as SectionGroup[]);

        this.fillSavedItems();

        if (this.updatingService && this.service) {
          this.fillSavedServiceInfo(this.service);
        }
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getPriceLevelsByCup(cups: string) {
    try {
      const priceLevels = await this.cupsPriceLevelService.getCupsPriceLevelById(
        cups
      );

      if (priceLevels.code === Http.Found && priceLevels.data) {
        this.cups = priceLevels.data.cups;
        this.priceLevels = Utils.getArrayByKeys(
          priceLevels.data.clients,
          SERVICES_CONTANTS.ATTRIBUTES
        );
      } else {
        this.cups = "";
        this.priceLevels = [];
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async handleModalAccept() {
    this.dialogAccept = false;
    let convertedData: SectionGroupData[] = [];

    if (this.serviceAssignType === GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED)
      convertedData = this.convertSectionGroups();

    try {
      const serviceToAssing: Service = {
        internalName: this.serviceTemplate.internalName,
        category: this.serviceTemplate.category,
        cups:
          this.serviceTemplate.type == this.GROUP_TYPE
            ? this.cupsSelected
            : this.serviceTemplate.cups || "",
        type: this.serviceTemplate.type,
        priceLevel: this.price,
        contractType: this.contractType,
        userType: this.userType,
        attentionType: this.attentionType,
        chargeConcept: this.chargeConcept,
        user: this.user,
        serviceTemplate: this.serviceTemplate.id || "",
        progress: 0,
        carer: "",
        attendedBy: "",
        medicalOrder: "",
        state: SERVICE_STATES.NOT_ASSIGNED,
        requiredPriorOrder: this.requiredOrder
      };

      if (this.serviceTemplate.type === this.GROUP_TYPE) {
        serviceToAssing.groups = convertedData;
        serviceToAssing.groupsFilled = {};
        serviceToAssing.sessionsFilled = {};
      } else {
        serviceToAssing.sections = convertedData;
        serviceToAssing.sectionsFilled = {};
        serviceToAssing.formTemplatesFilled = {};
      }
      if (!this.justStepper) {
        const response = await this.servicesService.assignService({
          ...serviceToAssing,
          externalOrderNumberForCreation: this.externalOrderNumber
        });
        if (response.code === Http.Ok) {
          this.close();
          this.$emit(SERVICES_CONTANTS.IDS.UPDATE_SERVICES);

          Snackbar.popSuccess(SERVICES_CONTANTS.MESSAGE.ASSIGNED);
        } else {
          Snackbar.popWarning(SERVICES_CONTANTS.MESSAGE.ASSIGN_FAILED);
        }
      } else {
        this.$emit(SERVICES_CONTANTS.IDS.SUCCESS, {
          serviceTemplateId: serviceToAssing.serviceTemplate,
          serviceToAssing
        });
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.POST}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  handleModalCancel() {
    this.dialogAccept = false;
  }

  async handleModalAcceptConfirm() {
    await this.getServiceTemplate(this.serviceId);
    this.dialogConfirm = false;
  }

  handleModalCancelConfirm() {
    this.dialogConfirm = false;
  }

  async assignService() {
    if (!this.serviceAssignType) {
      Snackbar.popWarning(SERVICES_CONTANTS.MESSAGE.SELECT_ASSIGN_SERVICE);
    } else {
      this.dialogAccept = await this.serviceBillingValidation();
    }
  }

  async serviceBillingValidation(): Promise<boolean> {
    try {
      if (this.serviceTemplate.id) {
        return true;
      } else {
        Snackbar.popError(SERVICES_CONTANTS.MESSAGE.NO_ID);
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
    return false;
  }

  cleanServiceConfig() {
    this.groupSectionSelected = "";
    this.groupSections = [];
    this.sessionsFormTemps = [];
    this.currentSectionGroups = [];
    this.currentItems = [];
    this.savedItems = [];
    this.serviceAssignType = "";
    this.groupSectionAssignType = "";
  }

  cleanGroups() {
    this.currentSectionGroups = this.groupSections?.slice() as SectionGroup[];
    this.savedItems = [];
    this.fillSavedItems();
    this.updatedGroupSections = false;
  }

  @Watch("groupSectionSelected")
  getFormSessions() {
    if (this.serviceTemplate.type === this.GROUP_TYPE) {
      this.sessionsFormTemps = this.serviceTemplate.groups?.find(
        i => i.key === (this.groupSectionSelected as SectionGroup).key
      )?.sessions as SectionGroupDetail[];
    } else {
      this.sessionsFormTemps = this.serviceTemplate.sections?.find(
        i => i.key === (this.groupSectionSelected as SectionGroup).key
      )?.formTemplates as SectionGroupDetail[];
    }

    const existGroup = this.currentSectionGroups.find(
      i => i.key === (this.groupSectionSelected as SectionGroup).key
    );
    const dataSelected = this.savedItems.find(
      i => i.key === (this.groupSectionSelected as SectionGroup).key
    );

    if (existGroup && dataSelected) {
      this.groupSectionAssignType = dataSelected.type.slice();
      this.currentItems = [...dataSelected.selected];
    } else {
      this.groupSectionAssignType = "";
      this.currentItems = [];
    }
  }

  fillSavedItems() {
    this.currentSectionGroups.forEach(item => {
      const itemOnSaved = this.savedItems.findIndex(
        savedItem => savedItem.key == item.key
      );
      const itemOnCurrent = this.currentSectionGroups.findIndex(
        currentItem => currentItem.key == item.key
      );
      if (
        itemOnSaved == EXTRA_CONSTANTS.MINUS_INDEX &&
        itemOnCurrent != EXTRA_CONSTANTS.MINUS_INDEX
      ) {
        this.savedItems.push({
          key: item.key,
          type: GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED,
          selected:
            this.serviceTempType === EXTRA_CONSTANTS.GROUP
              ? (item.sessions as SectionGroupDetail[])
              : (item.formTemplates as SectionGroupDetail[])
        });
      }
    });
  }

  fillSavedServiceInfo(service: ServiceHeaderData) {
    this.price = service.priceLevel ?? "";
    this.externalOrderNumber = service.externalOrderNumberForCreation ?? "";
    if (service.sections && service.type === this.SECTION_TYPE) {
      if (service.sections.length > 0) {
        this.serviceAssignType = GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED;
        this.savedItems = this.matchSelectedItems(
          service.sections,
          this.savedItems
        );
      } else {
        this.serviceAssignType = GENERAL_CONSTANTS.ASSIGN_TYPE.COMPLETE;
      }
    } else if (service.groups && service.type === this.GROUP_TYPE) {
      if (service.groups.length > 0) {
        this.serviceAssignType = GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED;
        this.savedItems = this.matchSelectedItems(
          service.groups,
          this.savedItems
        );
      } else {
        this.serviceAssignType = GENERAL_CONSTANTS.ASSIGN_TYPE.COMPLETE;
      }
    }
  }

  matchSelectedItems(
    sections: SectionGroupData[],
    savedItems: SavedItems[]
  ): SavedItems[] {
    return savedItems.map(savedItem => {
      const section = sections.find(section => section.key === savedItem.key);
      if (section) {
        let selected: SectionGroupDetail[] = [];
        if (section.formTemplates) {
          selected = savedItem.selected.filter(item =>
            (section.formTemplates as SectionGroupDetailShort[]).some(
              template => template.id === item.id
            )
          );
        } else if (section.sessions) {
          selected = savedItem.selected.filter(item =>
            section.sessions?.includes(item.id)
          );
        }

        const type =
          selected.length > 0
            ? GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED
            : GENERAL_CONSTANTS.ASSIGN_TYPE.COMPLETE;
        return { ...savedItem, type, selected };
      }
      return savedItem;
    });
  }

  setSectionGroup() {
    if (this.groupSectionAssignType === "")
      return Snackbar.popInfo(
        this.serviceTemplate.type === this.GROUP_TYPE
          ? SERVICES_CONTANTS.MESSAGE.SELECT_ASSIGN_GROUP
          : SERVICES_CONTANTS.MESSAGE.SELECT_ASSIGN_SECTION
      );
    if (
      this.groupSectionAssignType ===
        GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED &&
      this.currentItems.length === 0
    )
      return Snackbar.popInfo(
        this.serviceTemplate.type === this.GROUP_TYPE
          ? SERVICES_CONTANTS.MESSAGE.SELECT_SESSIONS
          : SERVICES_CONTANTS.MESSAGE.SELECT_FORM_TEMPS
      );

    if (
      !this.currentSectionGroups.find(
        i => i.key === (this.groupSectionSelected as SectionGroup).key
      )
    ) {
      this.currentSectionGroups.push(this.groupSectionSelected as SectionGroup);
    }

    const valueExist = this.savedItems.find(
      i => i.key === (this.groupSectionSelected as SectionGroup).key
    );

    if (valueExist) {
      valueExist.selected =
        this.groupSectionAssignType === GENERAL_CONSTANTS.ASSIGN_TYPE.COMPLETE
          ? []
          : [...this.currentItems];
      valueExist.type = this.groupSectionAssignType;
    } else {
      this.savedItems.push({
        key: (this.groupSectionSelected as SectionGroup).key,
        selected:
          this.groupSectionAssignType === GENERAL_CONSTANTS.ASSIGN_TYPE.COMPLETE
            ? []
            : [...this.currentItems],
        type: this.groupSectionAssignType
      });
    }

    this.handleSectionsChange(this.serviceAssignType, true);

    this.currentItems = [];
    this.groupSectionSelected = "";
    this.groupSectionAssignType = "";

    this.updatedItem = true;
    setTimeout(() => {
      this.updatedItem = false;
    }, 450);
  }

  onTagSelected(id: string) {
    this.groupSectionSelected =
      this.currentSectionGroups.find(i => i.key === id) ?? "";
  }

  onTagClosed(index: number) {
    this.currentSectionGroups.splice(index, 1);
    this.savedItems.splice(index, 1);
    this.groupSectionSelected = "";
    this.groupSectionAssignType = "";
    this.currentItems = [];
    this.updatedGroupSections = true;
  }

  convertSectionGroups(): SectionGroupData[] {
    const data: SectionGroupData[] = [];

    if (this.serviceTemplate.type === this.GROUP_TYPE) {
      this.savedItems.forEach(s => {
        data.push({
          key: s.key,
          sessions: s.selected.map(i => i.id)
        });
      });
    } else {
      this.savedItems.forEach(section => {
        data.push({
          key: section.key,
          formTemplates: section.selected.map(item => ({
            id: item.id,
            multiple: item.multiple
          }))
        });
      });
    }
    return data;
  }

  async allowSeveralInstances(serviceId: string) {
    try {
      const response = await this.serviceTemplateService.verifymultipleInstances(
        serviceId
      );

      if (response.code === Http.Found && response.message) {
        return response.message;
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  closeModalAllowSeveralInstances() {
    this.dialogAllowSeveralInstances = false;
  }

  async onBottomServiceScroll(e: any) {
    const { scrollTop, offsetHeight, scrollHeight } = e.target;
    if (scrollTop + offsetHeight >= scrollHeight - 1) {
      await this.searchData(this.filterItems, true);
    }
  }

  async getCupsByService(arrayOfCups: string[]) {
    try {
      this.serviceCups = [];
      for (const cupsId of arrayOfCups) {
        const responseData = await this.cupsPriceLevelService.getCupsPriceLevelById(
          cupsId
        );
        if (
          responseData.code === Http.Found &&
          responseData.data !== undefined
        ) {
          this.serviceCups.push({
            key: responseData.data.id as string,
            name: responseData.data.externalName
          });
        }
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICE_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getContractTypes() {
    this.contractTypes = await this.getListById(SERVICE_LIST_IDS.CONTRACT_TYPE);
  }
  async getUserTypes() {
    this.userTypes = await this.getListById(SERVICE_LIST_IDS.USER_TYPE);
  }
  async getAttentionTypes() {
    this.attentionTypes = await this.getListById(
      SERVICE_LIST_IDS.ATTENTION_TYPE
    );
  }
  async getChargeConcepts() {
    this.chargeConcepts = await this.getListById(
      SERVICE_LIST_IDS.CHARGE_CONCEPT
    );
  }

  async getListById(id: string): Promise<ArrayByKeys[]> {
    try {
      const responseData = await this.listService.getListById(id);

      if (responseData.code === Http.Found && responseData.data) {
        const dataList = responseData.data.optionsSchema;
        return dataList.map(data => {
          return { key: data.const, name: data.title };
        });
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
        return [];
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      return [];
    }
  }

  @Watch("cupsSelected")
  async onSelectCups() {
    if (this.serviceTemplate.type == this.GROUP_TYPE) {
      await this.getPriceLevelsByCup(this.cupsSelected);
    }
  }
}
